import {CanMatchFn} from '@angular/router';
import {inject} from '@angular/core';
import {AuthService} from '../../services/auth/auth.service';
import {jwtDecode, JwtPayload} from 'jwt-decode';

export const authGuard: CanMatchFn = (_route, _segments) => {
  const _authService: AuthService = inject(AuthService);

  const accessToken: string = _authService.accessToken();

  if (accessToken) {
    const decodedToken: JwtPayload = jwtDecode(accessToken);
    const isTokenExpired: boolean = decodedToken && decodedToken.exp ? decodedToken.exp < Date.now() / 1000 : false;

    if (isTokenExpired) {
      _authService.logout();
      return false;
    } else {
      return true;
    }

  } else {
    _authService.logout();
    return false;
  }

};
